/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAdyenCredentials200Response
 */
export interface GetAdyenCredentials200Response {
    /**
     * 
     * @type {string}
     * @memberof GetAdyenCredentials200Response
     */
    identifier: string;
    /**
     * 
     * @type {string}
     * @memberof GetAdyenCredentials200Response
     */
    passphrase: string;
    /**
     * 
     * @type {number}
     * @memberof GetAdyenCredentials200Response
     */
    version: number;
}

/**
 * Check if a given object implements the GetAdyenCredentials200Response interface.
 */
export function instanceOfGetAdyenCredentials200Response(value: object): value is GetAdyenCredentials200Response {
    if (!('identifier' in value) || value['identifier'] === undefined) return false;
    if (!('passphrase' in value) || value['passphrase'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function GetAdyenCredentials200ResponseFromJSON(json: any): GetAdyenCredentials200Response {
    return GetAdyenCredentials200ResponseFromJSONTyped(json, false);
}

export function GetAdyenCredentials200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdyenCredentials200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'identifier': json['identifier'],
        'passphrase': json['passphrase'],
        'version': json['version'],
    };
}

export function GetAdyenCredentials200ResponseToJSON(json: any): GetAdyenCredentials200Response {
    return GetAdyenCredentials200ResponseToJSONTyped(json, false);
}

export function GetAdyenCredentials200ResponseToJSONTyped(value?: GetAdyenCredentials200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identifier': value['identifier'],
        'passphrase': value['passphrase'],
        'version': value['version'],
    };
}

